class Toolbarmobile extends HTMLElement {
  connectedCallback() {
    if (this.resizeObserver) return;
    this.mobileQuery = window.matchMedia('(max-width: 989px)');
    this.refresh = () => {
      this.activate();
      this.setHeight();
    };
    this.refreshCounts = () => {
      this.querySelectorAll('.cart-count-bubble').forEach(bubble => {
        const count = bubble.querySelector('[data-cart-count]')?.textContent.trim();
        bubble.dataset.empty = String(!count || count === '0');
      });
    };
    window.addEventListener('resize', this.refresh);
    this.resizeObserver = new ResizeObserver(this.refresh);
    this.resizeObserver.observe(this, {box: 'border-box'});
    this.countObserver = new MutationObserver(this.refreshCounts);
    this.countObserver.observe(this, {childList: true, characterData: true, subtree: true});
    const header = document.querySelector('.header');
    if (header) {
      this.headerObserver = new MutationObserver(this.refresh);
      this.headerObserver.observe(header, {attributes: true, attributeFilter: ['data-sticky-state']});
    }
    this.refreshCounts();
    this.refresh();
  }

  activate() {
    const inactiveHeader = document.querySelector('.header[data-sticky-state="inactive"]');
    this.classList.toggle('active', this.mobileQuery.matches && !inactiveHeader);
  }

  setHeight() {
    const visible = this.mobileQuery.matches && this.classList.contains('active') && window.getComputedStyle(this).display !== 'none';
    const height = visible ? Math.ceil(this.getBoundingClientRect().height) : 0;
    document.body.style.setProperty('--toolbar-mobile-height', `${height}px`);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.refresh);
    this.resizeObserver?.disconnect();
    this.countObserver?.disconnect();
    this.headerObserver?.disconnect();
    this.resizeObserver = null;
    if (!document.querySelector('toolbar-mobile.active')) {
      document.body.style.removeProperty('--toolbar-mobile-height');
    }
  }
}

if (!customElements.get('toolbar-mobile')) {
  customElements.define('toolbar-mobile', Toolbarmobile);
}
